export default "__VITE_ASSET__9n8FAeT2__"